(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["image-bar-thebox-1"] && !Shopify.designMode) return;
  try {
    
	
  function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-thebox-2"] && !Shopify.designMode) return;
  try {
    
	
  function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-thebox-3"] && !Shopify.designMode) return;
  try {
    
	
  function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-bar-thebox"] && !Shopify.designMode) return;
  try {
    
	
  function initSlider() {
    var $sliderSelector = $('.slider-thebox');
    var $sliderContainer = $sliderSelector.closest('.slideshow-wrapper');

	if (!$sliderSelector.length) {
		return false;	
	}

    /* Slider settings */
    var settings = {
      accessibility: true,
      arrows: false,
      dots: false,
      fade: true,
      draggable: true,
      touchThreshold: 20,
      centerMode: true,
      centerPadding: '40px',
      slidesToShow: 1,
      mobileFirst: true,
      responsive: [{
        breakpoint: 767,
        settings: "unslick"
      }]
    }

    // data options
    settings.autoplay = $sliderSelector.data('autorotate');
    settings.autoplaySpeed = $sliderSelector.data('speed');

    var adaptHeight = $sliderSelector.data('adapt-height');
    var minAspectRatio = $sliderSelector.data('min-aspect-ratio');
    var sideArrows = $sliderSelector.data('side-arrows');

    if (adaptHeight) {
      $sliderSelector.height($(document).width() / minAspectRatio);
      $(window).resize($.debounce(50, function() {
        $sliderSelector.height($(document).width() / minAspectRatio);
      }));
    }

    var slider = $sliderSelector.slick(settings);

    var $prevArrow = $sliderContainer.find('.side-arrow.side-arrow-left')
    var $nextArrow = $sliderContainer.find('.side-arrow.side-arrow-right')

    if (sideArrows && $sliderSelector.hasClass('slick-initialized')) {
      if ($prevArrow && $prevArrow.length) {
        $prevArrow.on('click', function() {
          $sliderSelector.slick('slickPrev');
        });
      }
      if ($nextArrow && $nextArrow.length) {
        $nextArrow.on('click', function() {
          $sliderSelector.slick('slickNext');
        });
      }
    }

    /* Do this every time window gets resized */
    $(window).on('resize', function() {
      if ($(window).width() < 767) {
      /* We are below mobile breakpoint, initialize the slider
        if it is not already initialized */
      if (!slider.hasClass('slick-initialized')){
          return slider.slick(settings);
        }
      }
    })
  }
                                  
  initSlider();



  } catch(e) { console.error(e); }
})();
})();
